import script from "./LilaDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LilaDialog.vue?vue&type=script&setup=true&lang=js"

import "./LilaDialog.vue?vue&type=style&index=0&id=5f405b3a&lang=css"

const __exports__ = script;

export default __exports__